import { takeEvery, call, put } from 'redux-saga/effects';
import { findFixtures } from './api';

import { receiveFixtures, REQUEST_FIXTURES } from './actions';

function* callAllFixtures({ payload }) {
  const allFixtures = yield call(findFixtures, payload);
  yield put(receiveFixtures(allFixtures.data));
}

export function* clubsSaga() {
  yield takeEvery(REQUEST_FIXTURES, callAllFixtures);
}



// WEBPACK FOOTER //
// ./src/modules/fixture/sagas.js